<template>
    <!-- Notification -->
   <span v-if="showNotification" class="clipboard-notification">
    Link copied
  </span>
  <ul class="social-share" :class="[props.class]">
  
    <li class="social-share__item">
      <a @click.prevent="copyToClipboard">
        <i class="icon-link"></i>
      </a>
     
    </li>
    <li class="social-share__item">
      <a @click.prevent="openPopup(lineShareUrl)">
        <i class="icon-line"></i>
      </a>
    </li>
    <li class="social-share__item">
      <a @click.prevent="openPopup(facebookShareUrl)">
        <i class="icon-facebook"></i>
      </a>
    </li>
    <li class="social-share__item">
      <a @click.prevent="openPopup(twitterShareUrl)">
        <i class="icon-twitter"></i>
      </a>
    </li>
    <li class="social-share__item">
      <a @click.prevent="openPopup(linkedInShareUrl)">
        <i class="icon-linkedin"></i>
      </a>
    </li>
  </ul>
</template>

<script setup>

const requestUrl = useRequestURL();
const currentUrl = computed(() => requestUrl.href);
const showNotification = ref(false);

const facebookShareUrl = computed(() => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl.value)}`);
const lineShareUrl = computed(() => `https://line.me/R/msg/text/?${encodeURIComponent(currentUrl.value)}`);
const twitterShareUrl = computed(() => `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl.value)}`);
const linkedInShareUrl = computed(() => `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl.value)}`);

const openPopup = (url) => {
  window.open(url, "popup", "width=600,height=400,scrollbars=no,resizable=no");
};

const copyToClipboard = () => {
  navigator.clipboard.writeText(currentUrl.value).then(() => {
    showNotification.value = true;
    setTimeout(() => {
      showNotification.value = false;
    }, 2000);
  });
};

// รับ props
const props = defineProps({
  class: String,
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";
.social-share {
  display: flex;
  align-items: center;
  list-style: none;
  gap: 8px;
  padding: 0;
  margin-bottom: 1.25rem;
  margin-top: 1rem;

  .social-share__item {
    height: 30px;
    width: 30px;
    background-color: $gray-2;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    a {
      text-decoration: none;
    }
    i {
      color: $black-2;
      font-size: px-to-rem(16);
      @include transition();
    }
    @include hover {
      i {
        color: $yellow-ci;
      }
    }
  }
}
.clipboard-notification {
  position: absolute;
  top: -18px;
  left: -18px;
  width: max-content;
  font-size: px-to-rem(10);
  background-color: $black;
  opacity: 0.8;
  color: $white;
  padding: 5px 5px;
  border-radius: 5px;
}
</style>